import moment from 'moment';
import 'moment-timezone';

interface IProps {
  date?: string | Date | null;
  timezone?: string;
}

const getTableTimestamp = ({ date, timezone }: IProps) =>
  moment(date)
    .tz(timezone ?? 'UTC')
    .format('MMM D, YYYY HH:mm');

export { getTableTimestamp };
